<app-tab-layout [loading]="loading()" [error]="error">
  @if (initialized()) {
    <app-api-table
      [endpoint]="'/promoter-sales/tables/product-analytics'"
      [name]="name"
      [chartColumn]="'Product Name'"
      [hasIndexCol]="true"
    ></app-api-table>
  }
</app-tab-layout>
